import { Variable } from '~/packages/variable/variables.typing'
import object, { ShapeBase } from '../object'

// @TODO: Implement variable type
export const variable = object<Variable & ShapeBase>({} as Variable & ShapeBase)
